import { Button, Col, Form, Input, Row, Space, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import { AddBtnSVG } from "assets";
import React, { useEffect, useImperativeHandle, useState } from "react";

const KetQuaDieuTri = React.forwardRef((props, ref) => {
  // const [dataTable, setDataTable] = useState(
  //   data?.ketQuaDieuTriOrthoK?.length > 0
  //     ? data?.ketQuaDieuTriOrthoK.map((el, i) => {
  //         if (i == 0) {
  //           const res = {
  //             ...el,
  //             noiDung: "Thị lực không kính Khúc xạ",
  //             lanKham: `Ngày`,
  //             sauNgay: "(Sau 3 tháng)",
  //           };
  //           return res;
  //         } else if (i === 1) {
  //           const res = {
  //             ...el,
  //             noiDung: "Thị lực không kính Khúc xạ",
  //             lanKham: `Ngày`,
  //             sauNgay: "(Sau 3 tháng)",
  //           };
  //           return res;
  //         } else if (i === 2) {
  //           const res = {
  //             ...el,
  //             noiDung: "Thị lực không kính Khúc xạ",
  //             lanKham: `Ngày`,
  //             sauNgay: "(Sau 3 tháng)",
  //           };
  //           return res;
  //         } else if (i === 3) {
  //           const res = {
  //             ...el,
  //             noiDung: "Thị lực không kính Khúc xạ",
  //             lanKham: `Ngày`,
  //             sauNgay: "(Sau 3 tháng)",
  //           };
  //           return res;
  //         } else {
  //           return { el };
  //         }
  //       })
  //     : data2
  // );
  const [dataTable, setDataTable] = useState([]);

  useImperativeHandle(ref, () => ({
    setDataTable: setDataTable,
    getData: () => dataTable,
  }));

  useEffect(() => {}, [dataTable]);
  const handleAdd = () => {
    setDataTable([
      ...dataTable,
      {
        key: dataTable.length + 1,
        noiDung: "",
        lanKham: ``,
        sauNgay: "",
        mp: "",
        edit: true,
        mt: "",
      },
    ]);
  };

  return (
    <div className="table-custom-othorK">
      <Row>
        <Typography.Title>KẾT QUẢ ĐIỀU TRỊ</Typography.Title>
      </Row>
      <table>
        <thead>
          <th>Lần khám</th>
          <th>Nội dung</th>
          <th>MP</th>
          <th>MT</th>
          <th>
            <Row>
              <Col span={20}>Ghi chú</Col>
              <Col span={4}>
                <Button size="small" icon={<AddBtnSVG />} onClick={handleAdd} />
              </Col>
            </Row>
          </th>
        </thead>
        <tbody>
          {dataTable.map((e, i) => {
            return (
              <tr>
                {/* {e.edit ? ( */}
                <>
                  <td>
                    <Form.Item name={["ketQuaDieuTriOrthoK", i, `lanKham`]}>
                      <Input />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item name={["ketQuaDieuTriOrthoK", i, `noiDung`]}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      style={{ display: "none" }}
                      name={["ketQuaDieuTriOrthoK", i, `id`]}
                      initialValue={null}
                    ></Form.Item>
                  </td>
                </>
                {/* ) : (
                  <>
                    <td>
                      <div style={{ textAlign: "center" }}>{e.lanKham}</div>
                      <div style={{ textAlign: "center" }}>{e.sauNgay}</div>
                    </td>
                    <td>
                      {e.noiDung}
                      <Form.Item
                        style={{ display: "none" }}
                        name={["ketQuaDieuTriOrthoK", i, `idPhieuKham`]}
                        initialValue={null}
                      ></Form.Item>
                    </td>
                  </>
                )} */}
                <td>
                  <Form.Item name={["ketQuaDieuTriOrthoK", i, `mp`]}>
                    <Input />
                  </Form.Item>
                </td>
                <td>
                  <Form.Item name={["ketQuaDieuTriOrthoK", i, `mt`]}>
                    <Input />
                  </Form.Item>
                </td>
                <td>
                  <Form.Item name={["ketQuaDieuTriOrthoK", i, `ghiChu`]}>
                    <TextArea rows={2}/>
                  </Form.Item>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
});

export default KetQuaDieuTri;
